import { render, staticRenderFns } from "./DeviceFilterReviewsSkeleton.vue?vue&type=template&id=5c94e103"
import script from "./DeviceFilterReviewsSkeleton.vue?vue&type=script&lang=js"
export * from "./DeviceFilterReviewsSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports